/**
 * IKAI SEO - Internal Linking Map (sanitized)
 */

export interface InternalLink {
  url: string;
  anchor: string;
}

export const internalLinkMap: Record<string, InternalLink[]> = {
  "/": [
    { url: "/yazilim/ik-yazilimi", anchor: "IK yazilimi" },
    { url: "/yazilim/hr-yazilimi", anchor: "HR yazilimi" },
    {
      url: "/yazilim/insan-kaynaklari-programi",
      anchor: "insan kaynaklari programi",
    },
    { url: "/features", anchor: "Platform ozellikleri" },
    { url: "/blog", anchor: "IK rehberleri" },
  ],
  "/yazilim": [
    { url: "/yazilim/mesai-takip-yazilimi", anchor: "mesai takip programi" },
    { url: "/yazilim/bordro-yazilimi", anchor: "bordro yazilimi" },
    { url: "/yazilim/aday-takip-sistemi", anchor: "aday takip sistemi" },
    { url: "/yazilim/ik-yazilimi", anchor: "ik yazilimi" },
    { url: "/features", anchor: "Platform yetenekleri" },
  ],
  "/cozumler": [
    { url: "/yazilim", anchor: "Modul bazli yazilim" },
    { url: "/features", anchor: "Ozellik detaylari" },
    { url: "/iletisim", anchor: "Iletisim" },
  ],
  "/blog": [
    { url: "/yazilim/aday-takip-sistemi", anchor: "ATS yazilimi" },
    { url: "/yazilim/mesai-takip-yazilimi", anchor: "mesai takip yazilimi" },
    { url: "/yazilim/cv-analiz-programi", anchor: "cv analiz programi" },
    {
      url: "/yazilim/maas-bordrosu-olusturucu",
      anchor: "maas bordrosu ornegi",
    },
  ],
  "/yazilim/mesai-takip-yazilimi": [
    { url: "/yazilim/puantaj-yazilimi", anchor: "puantaj yazilimi" },
    { url: "/yazilim/bordro-yazilimi", anchor: "bordro entegrasyonu" },
    {
      url: "/blog/mesai-takip-programi-nedir-nasil-secilir",
      anchor: "mesai takip programi rehberi",
    },
  ],
  "/yazilim/maas-bordrosu-olusturucu": [
    { url: "/yazilim/bordro-yazilimi", anchor: "bordro yazilimi" },
    {
      url: "/yazilim/maas-hesaplama-programi",
      anchor: "maas hesaplama programi",
    },
    { url: "/araclar/maas-hesaplayici", anchor: "maas hesaplayici" },
  ],
  "/yazilim/bordro-yazilimi": [
    {
      url: "/yazilim/maas-bordrosu-olusturucu",
      anchor: "ucretsiz bordro programi ve pdf bordro ornegi",
    },
    {
      url: "/yazilim/maas-hesaplama-programi",
      anchor: "bordro hesaplama akisi",
    },
    { url: "/cozumler/bordro", anchor: "kurumsal bordro surecleri" },
  ],
  "/yazilim/aday-takip-sistemi": [
    { url: "/yazilim/ats-yazilimi", anchor: "ATS yazilimi" },
    { url: "/yazilim/ise-alim-yazilimi", anchor: "ise alim yazilimi" },
    { url: "/yazilim/cv-analiz-programi", anchor: "cv analiz platformu" },
    {
      url: "/blog/ats-aday-takip-sistemi-nedir-rehber",
      anchor: "aday takip sistemi nedir",
    },
  ],
  "/yazilim/cv-analiz-programi": [
    {
      url: "/yazilim/ai-cv-analizi",
      anchor: "AI destekli analiz icin",
    },
    { url: "/yazilim/aday-takip-sistemi", anchor: "aday takip sistemi cv" },
    { url: "/yazilim/ise-alim-yazilimi", anchor: "ise alim yazilimi" },
    {
      url: "/blog/yapay-zeka-ile-cv-analizi-rehberi",
      anchor: "cv analizi rehberi",
    },
  ],
  "/yazilim/ai-cv-analizi": [
    {
      url: "/yazilim/cv-analiz-programi",
      anchor: "cv analiz programi",
    },
    {
      url: "/yazilim/aday-takip-sistemi",
      anchor: "aday degerlendirme akisi",
    },
  ],
  "/yazilim/izin-takip-programi": [
    { url: "/cozumler/izin-yonetimi", anchor: "izin takip modulu" },
    { url: "/araclar/izin-hesaplayici", anchor: "ise giris yili hesaplama" },
    { url: "/yazilim/yillik-izin-yazilimi", anchor: "yillik izin yazilimi" },
  ],
  "/yazilim/ik-yonetim-sistemi": [
    { url: "/cozumler/calisan-yonetimi", anchor: "ik organizasyon yapisi" },
    { url: "/features", anchor: "organizasyon semasi ozellikleri" },
    { url: "/about", anchor: "ik ekip yapisi" },
  ],
  "/yazilim/ik-yazilimi": [
    { url: "/yazilim", anchor: "ik yazilim katalogu" },
    { url: "/yazilim/ik-formlari-kutuphanesi", anchor: "ik formlari" },
    {
      url: "/yazilim/insan-kaynaklari-programi",
      anchor: "insan kaynaklari programi",
    },
  ],
  "/yazilim/insan-kaynaklari-programi": [
    {
      url: "/blog/ik-programi-nedir-isletmenize-neden-gerekli",
      anchor: "ik programi rehberi",
    },
    { url: "/yazilim/ik-yazilimi", anchor: "ik yazilimi" },
    { url: "/yazilim/aday-takip-sistemi", anchor: "aday takip sistemi" },
  ],
  "/araclar/agi-hesaplayici": [
    {
      url: "/blog/agi-hesaplama-2026-tam-rehber",
      anchor: "agi hesaplama 2026 rehberi",
    },
    { url: "/araclar/maas-hesaplayici", anchor: "maas hesaplayici" },
    {
      url: "/yazilim/maas-bordrosu-olusturucu",
      anchor: "maas bordrosu ornegi pdf",
    },
  ],
  "/araclar/izin-hesaplayici": [
    { url: "/yazilim/izin-takip-programi", anchor: "izin takip modulu" },
    { url: "/yazilim/yillik-izin-yazilimi", anchor: "yillik izin yazilimi" },
  ],
};

export function getInternalLinks(pathname: string): InternalLink[] {
  return internalLinkMap[pathname] || [];
}
